import { createRoute, redirect } from "@tanstack/solid-router";
import { appRoute } from "./route";

/**
 * The mailbox is Cartero's home. The template's todo dashboard was removed, so
 * the bare in-app root just redirects to `/mail` (kept as a route so the sidebar
 * has one canonical mailbox target and deep-links stay stable).
 */
export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  beforeLoad: ({ search }) => {
    // oxlint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: "/mail", search, replace: true });
  },
});
